import axios from 'axios';
import { Config } from '../config';
import { IdCardDto, IdCardSearchDto } from '@/model/idCard.dto';

export class IdCardApi {
  public async getIdCardCheck(
    accessToken: string,
    phone: string,
  ): Promise<any> {
    const url = `${Config.API_URL}/console/access/certification/check/${phone}`;
    const headers = {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    };
    return await axios.get(url, { headers });
  }
  public async getIdCardList(
    accessToken: string,
    dto: IdCardSearchDto,
  ): Promise<IdCardDto[]> {
    const url = `${Config.API_URL}/console/access/certification`;
    const headers = {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    };
    const params = dto;
    const res = await axios.get(url, { headers, params });
    return res.data;
  }
  public async getFilterIdCardList(
    accessToken: string,
    dto: IdCardSearchDto,
  ): Promise<IdCardDto[]> {
    const url = `${Config.API_URL}/console/access/certification`;
    const headers = {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    };
    const params = dto;
    const res = await axios.get(url, { headers, params });
    return res.data;
  }

  public async postIdCardAdd(
    accessToken: string,
    dto: IdCardDto,
  ): Promise<any> {
    const url = `${Config.API_URL}/console/access/certification`;
    const headers = {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    };
    await axios.post<IdCardDto>(url, dto, { headers });
  }

  public async putIdCardModify(
    accessToken: string,
    id: number,
    dto: IdCardDto,
  ): Promise<any> {
    const url = `${Config.API_URL}/console/access/certification/${id}`;
    const headers = {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    };
    await axios.put<IdCardDto>(url, dto, { headers });
  }

  public async delIdCardList(accessToken: string, ids: number[]): Promise<any> {
    const url = `${Config.API_URL}/console/access/certification`;
    const headers = {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    };
    ids.map(async (id) => {
      const params = {
        ids: id,
      };
      await axios.delete(url, { headers, params });
    });
  }
}
